import { intervalDurationInMinutes } from "./IntervalHelper";

export const calculateTotalPriceFromBookingConfig = (booking, bookingConfig) => {
    const bookingLength = intervalDurationInMinutes(booking);

    if (bookingConfig.is_variable) {
        return calculateVariableBookingPrice(bookingConfig.payment_amount, bookingLength);
    } else {
        return calculateFixedSlotPrice(bookingConfig.payment_amount, bookingLength, bookingConfig.duration);
    }
}

export const calculateVariableBookingPrice = (hourlyPrice, bookingLength) => {
    const pricePerMinute = hourlyPrice / 60;
    return Math.round(pricePerMinute * bookingLength);
}

export const calculateFixedSlotPrice = (slotPrice, bookingLength, timeslotDuration) => {
    const numberOfSlots = Math.ceil(bookingLength / timeslotDuration);
    return slotPrice * numberOfSlots;
}

export const calculateTax = (totalPrice, taxPercentage = 20) => {
    const taxMultiplier = (100 - taxPercentage) / 100;
    return totalPrice - Math.round(totalPrice * taxMultiplier);
}

export const formatPrice = (penceTotal, symbol = '£') => {
    const pounds = Math.floor(penceTotal / 100);
    let pence = penceTotal % 100;
    pence = (pence < 10)
        ? '0' + pence
        : pence;

    return `${symbol}${pounds}.${pence}`;
}
